const APP_ENV = process.env;
export const CONSTANT = {
  PREFIX_ADMIN: APP_ENV.REACT_APP_PREFIX_ADMIN_URL,
  TIME_OUT: +APP_ENV.REACT_APP_TIME_OUT,
  LIMIT_EXPORT: +APP_ENV.REACT_APP_LIMIT_EXPORT,
};
